import { LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { IBaseModel } from '../models/base.model';
import { BaseService } from './base.service';
import { Subject } from 'rxjs';
import { IOsaExecucaoPapelTrabalho } from '../models/osa-execucao-papel-trabalho.model';

@Injectable({
  providedIn: 'root',
})
export class OsaExecucaoPapelTrabalhoService extends BaseService {

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public obterPorExecucao(osaExecucaoId: number): Promise<IBaseModel<IOsaExecucaoPapelTrabalho[]>> {
    return this.httpClient
        .get<IBaseModel<IOsaExecucaoPapelTrabalho[]>>(`${this.apiBaseUrl}/OsaExecucaoPapelTrabalho/${osaExecucaoId}`)
        .toPromise();
  }

  public async salvar(models: IOsaExecucaoPapelTrabalho[], removidos: IOsaExecucaoPapelTrabalho[], osaExecucaoId: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoPapelTrabalho`, { inserir: models, remover: removidos, osaExecucaoId: osaExecucaoId })
      .toPromise();
  }

  public async downloadAnexo(id: number): Promise<IBaseModel<IOsaExecucaoPapelTrabalho>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoPapelTrabalho>>(
        `${this.apiBaseUrl}/OsaExecucaoPapelTrabalho/${id}/download`, {})
      .toPromise();
  }
}
